import type { SamplesFilters } from "@services/samples/list/type";

export const defaultFilters: SamplesFilters = {
  type: "",
  reporterId: "",
  individualId: "",
  taxonomicGroupId: "",
  sampleDateStart: "",
  sampleDateEnd: "",
};
